import React, { useEffect, useState } from "react";
import { useUser } from "../context/userContext";
import { getUserPosts, removeTokens } from "../api/axios";
import { useNavigate } from "react-router-dom";

const Annoucement = () => {
  const user = useUser();
  console.log(user.user.points);
  const [likes, setLikes] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    getUserPosts({ access: user.token }).then((res) => {
      setLikes((res.data.likes || 0) + user.user.points);
    });
  }, []);
  return (
    <div className="bdy">
      <div className="plain" />
      <div className="xlbox">
        <h1>Announcements</h1>
        <div className="downbox">
          <div className="prjcts">
            <div className="pqx">
              <img
                src="https://builtin.com/sites/www.builtin.com/files/styles/og/public/2022-09/blockchain.png"
                alt="post"
                className="ps"
              />
            </div>
            <div className="infor">
              <h4>Blockchain for beginners</h4>
              <ul>
                <li>Date of Conduction: 30/05/2023</li>
                <li>Registration Fee: ₹150</li>
                <div className="or_box">
                  <li className="btns">pay ₹150</li>
                  {likes > 0 && (
                    <>
                      <li className="or">OR</li>
                      <li
                        className="btns"
                        onClick={() => {
                          removeTokens({
                            tokens: likes,
                            access: user.token,
                          }).then((res) => {
                            navigate("/" + user.user.usn);
                          });
                        }}
                      >
                        pay {150 - likes}+{likes} tokens
                      </li>
                    </>
                  )}
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Annoucement;
